import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StihlCampaignOrderCrmDTO, StihlCampaignOrderCrmPostDTO, StihlCampaignOrderCrmSendTestDTO, StihlCampaignOrderPubDTO, StihlCampaignOrderPubPostDTO } from '../models/stihl-campaign-dto';
import { DataTablesResponse } from '../models/datatables';

@Injectable({
  providedIn: 'root'
})

export class CampaignOrderService {

  private pathAPI = environment.urlAPI;
  private controller = "StihlCampaignOrder/";


  // private headers = new HttpHeaders({
  //   'Content-Type': 'application/json',
  //   'Accept': 'application/json'
  // });
  // private options = { headers: this.headers };


  constructor(private http: HttpClient) {

  }

  public CheckExistingOrder(idDistribuidor: number, idCampaign: string, idMaterialMedia: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + '/CheckExistingOrder/' + idDistribuidor + "/" + idCampaign + "/" + idMaterialMedia);
  }

  public postOrderPub(data: StihlCampaignOrderPubPostDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'PostOrderPub', data);
  }

  public postOrderCrm(data: StihlCampaignOrderCrmPostDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'PostOrderCrm', data);
  }

  public getOrderCrmById(idOrder): Observable<StihlCampaignOrderCrmDTO> {
    return this.http.get<StihlCampaignOrderCrmDTO>(this.pathAPI + this.controller + 'GetOrderCrmById/' + idOrder);
  }

  public getOrderPubById(idOrder): Observable<StihlCampaignOrderPubDTO> {
    return this.http.get<StihlCampaignOrderPubDTO>(this.pathAPI + this.controller + 'GetOrderPubById/' + idOrder);
  }

  public postCampaignCrmBlacklist(idOrderData: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'PostCampaignCrmBlacklist/' + idOrderData);
  }

  public SendTestCrm(datos: StihlCampaignOrderCrmSendTestDTO): Observable<any> {

    return this.http.post<any>(this.pathAPI + this.controller + 'SendTestCrm', datos);
  }

  public SendTestCrmByIdOrder(idOrder: string, email: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'SendTestCrmByIdOrder/' + idOrder + "/" + email);
  }

  public getCampaignCountData(idStatus, IdDistributor): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetOrderCrmCountData/' + idStatus + '/' + IdDistributor);
  }

  public getDatatableOrderCrm(data: any, IdDistributor: number, IdStatus: number): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDatatableOrderCrm/' + IdDistributor + "/" + IdStatus, data);
  }

  public getDatatableOrderPub(data: any, IdDistributor: number): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDatatableOrderPub/' + IdDistributor, data);
  }

  public changeStatusOrderCrm(id: string, idStatus: number) {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatusOrderCrm/' + id + '/' + idStatus, null);
  }

  public changeStatusOrderPub(id: string, idStatus: number) {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatusOrderPub/' + id + '/' + idStatus, null);
  }


  public getDataChartSendMail(idOrder: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetDataChartSendMail/' + idOrder);
  }

  public getDataChartMailsOpened(idOrder: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetDataChartMailsOpened/' + idOrder);
  }

  public getDataChartMailsClick(idOrder: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetDataChartMailsClick/' + idOrder);
  }

  public getStatisticsCrmDevice(idOrder: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetStatisticsCrmDevice/' + idOrder);
  }

  public getStatisticsCrmExcel(idOrder: string): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetCampaignOrderCrmExcel/' + idOrder;
    return this.http.get<Blob>(endpoint, requestOptions);
  }

  getCampaignOrderPubVallaExcel(): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetCampaignOrderPubVallaExcel/';
    return this.http.get<Blob>(endpoint, requestOptions);
  }

}
